import React from 'react';
import Hero from '../components/sections/Hero';
import HowItWorks from '../components/sections/HowItWorks';
import FeaturedExperts from '../components/sections/FeaturedExperts';
import Categories from '../components/sections/Categories';
import CTA from '../components/sections/CTA';
import Navbar from '../components/layout/Navbar';
import Footer from '../components/layout/Footer';
import Featured from '../assets/featured.jpeg';

const LandingPage = () => (
  <main>
    <Navbar />
    <Hero />
    {/* <HowItWorks /> */}
     <section className="bg-cream-50 ">
      <img
        src={Featured}
        alt="How TourEnt Hub Works"
        className="w-full shadow-xl"
      />
    </section>
    {/* <FeaturedExperts /> */}
    {/* <Categories /> */}
    <CTA />
    <Footer />
  </main>
);

export default LandingPage;
